<div class="error-container">
  <div class="error-content">
    <h2 class="error-number">404</h2>
    <p class="error-message">ไม่มีหน้าที่คุณต้องการ</p>
    <button mat-flat-button  class="home-button" (click)="goToHome()">กลับไปยังหน้าแรก</button>
  </div>
</div>
